<template>
  <div class="content-box">

    <div class="sub-catalog">
        <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">首頁</el-breadcrumb-item>
                <el-breadcrumb-item>搜索结果</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="sub-line"></div>



    <div class="content">
      <div class="left-content">
        <div class="left-content-box">
          <div style="margin-left:-50px">
              <img src="../assets/icon/class.png">
          </div>



          <el-menu 
            mode="vertical"
            @select="handleSelect"
          >
            <el-menu-item class="left-tab" index="0"  @click="leftbtn('全部')">
              <div>全部</div>
            </el-menu-item>
            
            <el-menu-item class="left-tab" index="1" @click="leftbtn('統計系列')">
              <span>
                統計系列
              </span>
            </el-menu-item>

             <el-menu-item class="left-tab" index="2"  @click="leftbtn('特種系列')">
               <span>
                特種系列
                </span>
              </el-menu-item>
            
            <el-menu-item class="left-tab" index="3" @click="leftbtn('雜項系列')">
              <span>
                雜項系列
              </span>
              </el-menu-item>

              <el-menu-item class="left-tab" index="4" @click="leftbtn('關務系列')">
              <span>
                關務系列
              </span>
              </el-menu-item>

              <el-menu-item class="left-tab" index="5" @click="leftbtn('總署系列')">
              <span>
                總署系列
              </span>
              </el-menu-item>

              <el-menu-item class="left-tab" index="6" @click="leftbtn('郵政系列')">
              <span>
                郵政系列
              </span>
              </el-menu-item>

              <el-menu-item class="left-tab" index="7" @click="leftbtn('他類系列')">
              <span>
                他類系列
              </span>
              </el-menu-item>
          </el-menu>

        </div>
        
      </div>

      <div class="right-content">

        <div class="search-select">
              <input v-model="searchtxt"
              class="input" placeholder="輸入關鍵詞搜索"/>
                
              <el-button class="search" @click="submitform"></el-button>
              <div class="gjjs">
                <router-link class="ro" :to="{ name: 'hgsearch' }">高級檢索></router-link>
              </div>
        </div>

        <div class="row1">
            <div class="dcwd" @click="exportExcel">
                <img style="height:19px;width:19px;" src="../assets/icon/download1.png">
                <span > 導出文檔</span>
            </div>
        </div>

        <div class="row2">





          <template>
            <el-table
            v-loading="pictLoading"
            element-loading-text="數據正在加載中"
            element-loading-spinner="el-icon-loading"
              @row-click="todetail"
              class="el-table"
              ref="multipleTable"
              :data="tableData"
              :row-style="tableRowStyle"
              :header-cell-style="tableHeaderColor"
              tooltip-effect="dark"
              style="margin-left:25px; width: 975px;">
              <el-table-column
                type="selection"
                width="55">
              </el-table-column>

              <el-table-column
                prop="gxsd_content_title"
                label="主題/表名"
                width="250">
              </el-table-column>
              <el-table-column
                prop="gxsd_data_class"
                label="類型"
                width="150">
              </el-table-column>
              <el-table-column
                prop="gxsd_date_time"
                label="時間"
                width="150">
              </el-table-column>
              <el-table-column
                prop="gxsd_publisher"
                label="來源"
                width="250">
              </el-table-column>
              <el-table-column
                prop="gxsd_main_language"
                label="語言">
              </el-table-column>
            </el-table>
            <div style="text-align: right;margin-top: 15px;">
              <el-pagination
                background
                v-show="ispage"
                :current-page="currentpage"
                :page-sizes="[20, 30, 50]"
                :page-size="pagesize"
                layout="total,sizes,prev, pager, next"
                :total="totalcount"
                @current-change="current_change"
                @size-change="size_change">
              </el-pagination>
            </div>
          </template>

        </div>

      </div>
      


        
    </div>
  </div>
</template>



<script>
import FileSaver from '../lib/FileSaver.min.js';
import XLSX from 'xlsx'
export default {
  name: "app",
  data() {
    return {
      totaldata:'99999',
      ispage:true,
      currentpage:1,
      pagesize:20,
      totalcount:10,
      activeIndex:'0',
      pictLoading:false,

      sclass:'全部',
      tableData:[],
      searchtxt:this.$route.query.searchtxt,
      fans:this.$route.query.isfan,
    };
  },
  methods: {
    //导出excel
    exportExcel(){
      var wb = XLSX.utils.table_to_book(document.querySelector('.el-table'))
      /* get binary string as output */
      var wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: true, type: 'array' })
      try {
        FileSaver.saveAs(new Blob([wbout], { type: 'application/octet-stream' }), 'sheetjs.xlsx')
      } catch (e) { if (typeof console !== 'undefined') console.log(e, wbout) }
      return wbout;
    },

    todetail(row){
      //row.ID;
      //console.log("行号id："+row.ID);
      this.$router.push({ path: "/hghome_datadetail",query:{bid:row.ID}});
    },

    current_change(val){
      this.currentpage=val;
      this.submitform();
    },
    size_change(val){
      this.pagesize=val;

      this.submitform();
    },

  //设置表格行的样式
   tableRowStyle({row,rowIndex}){
     let st;
     if(rowIndex%2==1){
       st={
         'background-color':'#f0f0f0',
       };

     }
     return st;
     },
      //设置表头行的样式
     tableHeaderColor({row,column,rowIndex,columnIndex}){
        return 'background-color:#d4c9bc;color:#9a7455;font-wight:500;font-size:16px;text-align:center;height: 50px';
      },

//获取查询结果
    submitform(){
      this.pictLoading=true;
      this.$http.get(`${this.$store.state.baseurl}/api/hghome/getsearchResult?&searchtxt=`+this.searchtxt+'&page='+this.currentpage+'&pagesize='+this.pagesize+'&sclass='+this.sclass).then(res=>{
        let json=JSON.parse(res.data);
        this.tableData=json.data;
        this.totalcount=json.dataSize;
        this.pictLoading=false;

        //console.log(this.totalcount);


      },err=>{

      })

    },
    leftbtn(a){
      this.sclass=a;
      this.submitform();
    },

    getTime(date) {
      return date;
    },
  },
  created() {
    this.pictLoading=true;
    this.$http.get(`${this.$store.state.baseurl}/api/hghome/getsearchResult?&searchtxt=`+this.searchtxt+'&page='+this.currentpage+'&pagesize='+this.pagesize+'&sclass='+this.sclass).then(res=>{
        let json=JSON.parse(res.data);
        this.tableData=json.data;
        this.totalcount=json.dataSize;
        this.pictLoading=false;

        //console.log(this.tableData);


      },err=>{

      })
  },
  
};
</script>


<style scoped lang="scss">
.content-box {
  display: flex;
  flex-direction: column;
  min-height:600px;
  width: 100%;
  background-color: #e5e2db;
  border-width: 0px 0px 1px 0px ;
	border-style: solid;
	border-color:#cec0b2;
}
.content {
  width: 1220px;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  flex-direction: row;
  justify-content: start;
  flex-wrap: wrap;
  .left-content{
    width:180px;
    min-height:600px;
    font-size: 16px;
    border-width: 0px 1px 0px 0px ;
	  border-style: solid;
	  border-color:#cec0b2;
    .left-content-box{

        margin-top: 16px;
        .left-tab :hover{
          background-color:#e5e2db !important ;
          color: #666666;
          font-weight: 550;

        }
        .left-tab{
          font-weight: 550;
          text-align: left;
          background: none;
          font-size: 16px;
          width: 100%;
          word-break: break-all !important;
          white-space: break-spaces !important; 
          span{
            white-space: nowrap !important;
          }
        }

       
      

    }
    
  }
  .right-content{
    width: 1000px;
  }
}

.sub-catalog{
  width: 1220px;
  margin-left: auto;
  margin-right: auto;
  text-align: left;
  font-size: 14px;
  color: #666666;
  padding-top: 14px;
  padding-bottom: 14px;
  
}
.sub-line{
  border-width: 0px 0px 1px 0px ;
	border-style: solid;
	border-color:#cec0b2;
}

.search-select {
  display: flex;
  justify-content: center;
  padding-top: 30px;
  .input {
    border-radius: 5px;
    width: 600px;
    height: 45px;
    padding-left: 20px;
    font-size: 14px;
    color: #999999;
    border: 0px;
  }
  .search {
    border-radius:5px;
    width: 100px;
    height: 45px;
    background: url("../assets/image/search.png") no-repeat;
    background-size:102px 45px;
    border-style: none;

  }
  .gjjs{
    font-size: 14px;
    padding-top: 15px;
    margin-left: 20px;
  }
  .gjjs a{
    text-decoration: none;
    color: #000;
  }
}

.row1{
    .dcwd{
        margin:20px 10px 20px 900px;
        width: 100px;
        text-align: right;
        img{
            width: 20px;
            height: 20px;

        }
        span{
            text-decoration: none;
            color: #906442;
        }
    }
}

.row2{
  margin-bottom: 10px;

    .el-table .success-row {
      background: #F3F3F3;
     }
    .tab-data{
        margin-left: 20px;
    
  }
}

.row3{
    padding: 0px 0px 15px 0px;
}

.c1{
  width: 50px;
}
.c2{
  width: 300px;
}
.c3{
  width: 100px;
}
.c4{
  width: 150px;
}
.c5{
  width: 300px;
}
.c6{
  width: 100px;
}



</style>